<template>
  <div>
    <Footer />
    <!-- <Info /> -->
  </div>
</template>

<script>
import Footer from './Footer'
import Info from './Info'

export default {
  name: 'Bottom',
  components: {
    Footer,
    Info
  }
}
</script>

<style>

</style>